import ApiService from '@/core/services/api.service'

/** @readonly */
export const COST_RECALC_RUN_STATUS = Object.freeze({
  DRAFT: 1,
  COMPUTED: 2,
  APPLIED: 3,
  CANCELLED: 4,
})

/** @readonly */
export const COST_RECALC_INVENTORY_DIMENSION = Object.freeze({
  PRODUCT: 1,
  IMEI: 2,
})

const runsBase = () => 'v1/inventory-cost-recalculation/runs'

/**
 * POST create run → axios response (check response.data.status + response.status for 200).
 */
export function createCostRecalculationRun(body) {
  return ApiService.post(runsBase(), body)
}

export function getCostRecalculationRun(runId) {
  return ApiService.get(`${runsBase()}/${runId}`)
}

/**
 * GET danh sách lô — query: companyId (bắt buộc), status?, limit?, offset?
 * Trả về envelope.data: { items, total, limit, offset }
 */
export function listCostRecalculationRuns(params) {
  return ApiService.query(runsBase(), { params })
}

/**
 * GET dòng preview lô — query tuỳ chọn: search hoặc q (tên / mã / barcode, LIKE), inventoryDimension?
 * (`1` = chỉ SP, `2` = chỉ IMEI, bỏ trống = cả hai)
 */
export function getCostRecalculationLines(runId, params = {}) {
  return ApiService.query(`${runsBase()}/${runId}/lines`, { params })
}

export function computeCostRecalculationRun(runId, body = {}) {
  return ApiService.post(`${runsBase()}/${runId}/compute`, body)
}

/** Tính lại lô đã có preview (xóa dòng cũ, chạy lại compute). Chỉ DRAFT/COMPUTED; APPLIED → 400. */
export function recomputeCostRecalculationRun(runId, body = {}) {
  return ApiService.post(`${runsBase()}/${runId}/recompute`, body)
}

export function applyCostRecalculationRun(runId, body = {}) {
  return ApiService.post(`${runsBase()}/${runId}/apply`, body)
}

export function runStatusLabel(status) {
  switch (Number(status)) {
    case COST_RECALC_RUN_STATUS.DRAFT:
      return 'Nháp'
    case COST_RECALC_RUN_STATUS.COMPUTED:
      return 'Đã tính'
    case COST_RECALC_RUN_STATUS.APPLIED:
      return 'Đã áp dụng'
    case COST_RECALC_RUN_STATUS.CANCELLED:
      return 'Đã hủy'
    default:
      return status != null ? String(status) : '—'
  }
}

export function inventoryDimensionLabel(d) {
  switch (Number(d)) {
    case COST_RECALC_INVENTORY_DIMENSION.PRODUCT:
      return 'Sản phẩm'
    case COST_RECALC_INVENTORY_DIMENSION.IMEI:
      return 'IMEI'
    default:
      return d != null ? String(d) : ''
  }
}

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

/**
 * Poll GET run until predicate(run, envelope) returns true or maxAttempts exhausted.
 * Optional isCancelled(): true để thoát và ném "Đã dừng chờ".
 */
export async function pollCostRecalculationRun(
  runId,
  predicate,
  { intervalMs = 3000, maxAttempts = 120, isCancelled } = {},
) {
  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    if (typeof isCancelled === 'function' && isCancelled()) {
      throw new Error('Đã dừng chờ')
    }
    const res = await getCostRecalculationRun(runId)
    const envelope = res.data
    const run = envelope && envelope.data
    if (run && predicate(run, envelope)) {
      return { res, run, envelope }
    }
    await sleep(intervalMs)
  }
  throw new Error('Hết thời gian chờ xử lý (worker có thể vẫn đang chạy).')
}
